import error from '../shared/decorators/error';

const ERRORS = {
  @error
  InvalidTagType(givenTagType) {
    this.name = 'Invalid Tag Type';
    this.message = `${givenTagType} is not a valid tag type!`;
  },
};

export default ERRORS;
